//var BASE_URL = 'http://localhost:8080/eloopRestAPI/ws/signup/';
// var BASE_URL = 'https://goldlasso.com/eloopRestAPI/ws/signup/';
var BASE_URL = "https://restapi.goldlasso.com/ws/signup/";

var LINK = {
  BASE_URL: BASE_URL,
  userExists: BASE_URL + 'userExists',
  isAgencyUser : BASE_URL+ 'isAgencyUser',
  createAccount : BASE_URL+ 'createAccount',
  sendEmailToAdmin : BASE_URL+ 'sendEmailToAdmin'
}

module.exports = LINK;



// WEBPACK FOOTER //
// ./src/constants/LinkConstants.js